import React from "react";

type Props = {
  rows?: number;
};

const Cell = ({ className }: { className: string }) => (
  <div className={`h-3 rounded bg-gray-200 animate-pulse ${className}`} />
);

export const CreditVouchersTableSkeleton: React.FC<Props> = ({ rows = 10 }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, i) => (
        <tr key={i} className="text-center odd:bg-white even:bg-gray-50">
          <td className="px-2 py-2 sm:px-4 sm:py-3 border-t border-gray-200">
            <div className="flex flex-col items-center gap-2">
              <Cell className="w-28 mx-auto" />
              <Cell className="w-20 mx-auto h-2" />
            </div>
          </td>
          <td className="px-2 py-2 sm:px-4 sm:py-3 border-t border-gray-200">
            <div className="flex justify-center">
              <div className="h-5 w-20 rounded-full bg-gray-200 animate-pulse" />
            </div>
          </td>
          <td className="px-2 py-2 sm:px-4 sm:py-3 border-t border-gray-200">
            <div className="flex justify-center">
              <div className="h-5 w-24 rounded-full bg-gray-200 animate-pulse" />
            </div>
          </td>
          <td className="px-2 py-2 sm:px-4 sm:py-3 border-t border-gray-200">
            <Cell className="w-20 mx-auto" />
          </td>
          <td className="px-2 py-2 sm:px-4 sm:py-3 border-t border-gray-200">
            <Cell className="w-32 mx-auto" />
          </td>
          <td className="px-2 py-2 sm:px-4 sm:py-3 border-t border-gray-200">
            <Cell className="w-32 mx-auto" />
          </td>
          <td className="px-2 py-2 sm:px-4 sm:py-3 border-t border-gray-200">
            <div className="flex justify-center">
              <div className="h-8 w-16 rounded bg-gray-200 animate-pulse" />
            </div>
          </td>
        </tr>
      ))}
    </>
  );
};

export default CreditVouchersTableSkeleton;
